import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import dateISO from 'src/filters/dateISO';

const query = gql`
query Report($dateFrom: String!, $dateTo: String!, $page: Int, $pageSize: Int) {
  activitiesReport(dateFrom: $dateFrom, dateTo: $dateTo, page: $page, pageSize: $pageSize) {
    activityDetailReportRows{
      activityId
      newTask
      channel
      caseId
      taskType
      taskStartTime
      queueTime
      completeTime
      agentName
      customerMessagesCount
      agentMessagesCount
      frt
      art
      maxRt
      closedType
      fcr,
      vote,
      comment
      markers
    }
    totalCount
    pageSize
  }
}`;

function getDetailReport({
  dateFrom, dateTo, page, pageSize,
}) {
  return apollo.client.query({
    variables: {
      dateFrom: dateISO(dateFrom),
      dateTo: dateISO(dateTo),
      page,
      pageSize,
    },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.activitiesReport);
}

export default getDetailReport;
